// Embedded-SSO configuration (AUTH_MODE=embedded) — the app runs inside the legacy
// .NET parent as an iframe and receives identity via a postMessage handshake rather
// than the IdP. Driven by REACT_APP_* (CRA bakes these at build time, so restart the
// dev server after changing them). Inert unless REACT_APP_AUTH_MODE=embedded — mutually
// exclusive with OIDC mode. See EMBEDDED_SSO.md §8.1.

export const EMBEDDED_ENABLED = (process.env.REACT_APP_AUTH_MODE || 'dummy').toLowerCase() === 'embedded';

// Allowed parent origins (comma-separated in REACT_APP_PARENT_ORIGIN) — e.g. the dev,
// uat, and prod Relius hosts. Multi-origin so ONE built image serves every environment:
// the handshake posts the request to each origin (only the real parent, matched by
// targetOrigin, receives it) and accepts a reply from any origin in this list. Adding a
// new environment is a list edit — no code change.
export const PARENT_ORIGINS = (process.env.REACT_APP_PARENT_ORIGIN || 'https://uat-www.webaccountlink.com')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

// sessionStorage key for the dashboard session token — sessionStorage (not local) so it
// is scoped to this tab/iframe and cleared when the tab closes.
export const EMBED_TOKEN_STORAGE_KEY = 'pcs_embed_token';

// How long to wait for the parent to answer the handshake before giving up.
export const HANDSHAKE_TIMEOUT_MS = 8000;
